import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AddAppointmentComponent } from '../add-appointment/add-appointment.component';
import { ViewAppointmentComponent } from '../view-appointment/view-appointment.component';
import { DoctorScheduleComponent } from '../doctor-schedule/doctor-schedule.component';
import { CommonServiceService } from '../../../component/common/common-service.service';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MyDatePickerModule  } from 'mydatepicker';
import { UserService } from '../../user/service/user.service';
import { AppointmentService } from '../service/appointment.service';
import { TimeslotMasterService } from '../../master/services/timeslot-master.service';
import { ClinicMasterService } from '../../master/services/clinic-master.service';
import { ServiceMasterService } from '../../master/services/service-master.service';
import { PatientService } from '../../patient/service/patient-service.service';
import { LoaderComponentAppointmentData } from '../../../shared/component/loader-data/loader.component';
import { CalendarComponent } from '../calendar/calendar.component';
import { ShowTaskComponent } from '../calendar/show-task.component';
import { UtilityService } from '../calendar/utility.service';
import { ShowTaskListComponent } from '../calendar/show-task-list.component';
import { EventPipe } from '../calendar/event.pipe';
import { CompleteComponent } from '../complete/complete.component';
import { PendingComponent } from '../pending/pending.component';
import { MissedComponent } from '../missed/missed.component';
@NgModule({
  imports: [
    CommonModule ,
    FormsModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    RouterModule.forChild([
            {path : 'viewappointment', component : ViewAppointmentComponent},
            {path : 'viewappointment/:id', component : ViewAppointmentComponent},
            {path : 'addschedule', component : DoctorScheduleComponent},
            {path : 'addschedule/:id', component : DoctorScheduleComponent},
            {path : 'complete', component : CompleteComponent},
            {path : 'pending', component : PendingComponent},
            {path : 'missed', component : MissedComponent}
          ])
  ],
  providers : [CommonServiceService, UserService, TimeslotMasterService, ClinicMasterService, AppointmentService, ServiceMasterService,PatientService, UtilityService],
  declarations: [ 
     ViewAppointmentComponent,
     DoctorScheduleComponent,
     LoaderComponentAppointmentData,
    AddAppointmentComponent,
     
     CompleteComponent,
     PendingComponent,
     MissedComponent
  ] ,
  exports: [RouterModule]
})
export class AppointmentRouteModule { }



// WEBPACK FOOTER //
// ./src/app/section/appointment/appointment-route/appointment-route.module.ts